import { Card, CardBody, Col, Table } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { TeamActivityTitle } from "../../../../../Constants/Constants";
import { Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Link } from "react-router-dom";
import { TeamActivityData } from "../../../../../Data/General/Dashboard/Default";

const TeamActivity = () => {
  return (
    <Col xl="5" sm="6">
      <Card>
        <DashboardCommonHeader title={TeamActivityTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="activity-table table-responsive custom-scrollbar">
            <Table className="order-table project-table w-100 activity-log">
              <tbody>
                {TeamActivityData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="team-activity">
                        <div className="activity-data d-flex align-items-center gap-3">
                          <div className="common-space gap-2">
                            <div className="user-activity me-3">
                              <Image className="rounded-circle p-1 img-fluid me-3 img-50" src={dynamicImage(item.image)} alt="user" />
                              <Link className="f-10 f-w-500 username" to={`${process.env.PUBLIC_URL}/applications/users/edit_profile`}>{item.title}</Link>
                            </div>
                            <div className="activity-time">
                              <span className="f-light f-w-500 f-10">{item.time}</span>
                            </div>
                          </div>
                          <div className="subtitle">
                            <P className="f-w-400 f-10">{item.text}</P>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TeamActivity;
